<template>
  <div class="row inset-box">
    <template v-if="isModalVisible">
      <div class="inset-box__container">
        <button @click="closeModal">
          <font-awesome-icon icon="times-circle" />
        </button>
        <img
          :src="modalImage.src"
          :alt="modalImage.alt" />
      </div>
    </template>
    <template v-else>
      <div
        class="column"
      >
        <img
          v-for="image in [1,2,3,]"
          :key="image"
          :src="`/images/projects/${project}/${project}${image}.png`"
          :alt="`Levi Image ${image}`"
          @click="showModal(`/images/projects/${project}/${project}${image}.png`,)"
        />
      </div>
      <div class="column">
        <img
          v-for="image in [4,5,6,]"
          :key="image"
          :src="`/images/projects/${project}/${project}${image}.png`"
          :alt="`Levi Image ${image}`"
          @click="showModal(`/images/projects/${project}/${project}${image}.png`,)"
        />
      </div>
      <div class="column">
        <img
          v-for="image in [7,8,]"
          :key="image"
          :src="`/images/projects/${project}/${project}${image}.png`"
          :alt="`Levi Image ${image}`"
          @click="showModal(`/images/projects/${project}/${project}${image}.png`,)"
        />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ProjectGallery',
  props: {
    project: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isModalVisible: false,
      modalImage: {
        src: '/images/projects/Levi1.png',
        alt: 'Levi Home Page'
      }
    }
  },
  methods: {
    showModal (imageSrc = null) {
      if (imageSrc) {
        this.modalImage.src = imageSrc
      }
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
/******
 * NOW EXTRA CSS HERE
 */
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}
.inset-box {
  /* background: #1a3256; */
  padding: 25px 0;
}
.column {
  flex: 33.3333%;
  max-width: 33.3333%;
  padding: 0 4px;
}
.column img {
  margin-top: 8px;
  vertical-align: middle;
  width: 100%;
  cursor: pointer;
  transition: $transition;

  &:hover {
    box-shadow: 1px 1px 20px 0px rgba(100, 255, 218, 0.4);
    width: 106%;
    margin-left: -3%;
    z-index: 99;
  }
}
@media screen and (max-width: 800px) {
  .column {
    flex: 50%;
    max-width: 50%;
  }
}
@media screen and (max-width: 600px) {
  .column {
    flex: 100%;
    max-width: 100%;
  }
}
.inset-box__container {
  flex: 100%;
  max-width: 100%;

  img {
    width: 100%;
  }

  button {
    position: absolute;
    right: 0;
    color: $green;
    cursor: pointer;
    font-size: 2rem;
    background: $navy;
    border-radius: 0 0 0 50%;
  }
}
</style>
